import React, { Component } from 'react';
import { translate } from 'react-i18next';
import {
    FormControl,
    FormGroup,
    InputGroup,
    ControlLabel,
    Col,
    Row,
    Checkbox
} from 'react-bootstrap';
import axios from 'axios';
import config from '../config';
import SpinnerButton from './SpinnerButton';
import DismissableAlert from './DismissableAlert';

import './EditFactTypeForm.css';

class EditFactTypeForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            saved: false,
            isLoading: false,
            facttypeTypes: this.props.facttypeTypes,
            facttype: {
                description: '',
                enabled: 'false'
            },
            error: {
                hidden: true,
                title: '',
                message: '',
                style: 'danger'
            }
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.facttype !== this.state.facttype) {
            if (nextProps.facttype) {
                this.setState({ facttype: nextProps.facttype });
            }
        }
    }

    componentDidMount() {}

    validateForm() {
        return this.state.facttype.description.length > 0;
    }

    handleChange = event => {
        const facttype = this.state.facttype;
        facttype[event.target.id] = event.target.value;

        // update state
        this.setState({
            facttype
        });
    };

    handleSubmit = event => {
        const { t } = this.props;

        event.preventDefault();

        this.setState({ isLoading: true });

        const id = this.state.facttype.id;

        // TODO: Validate that it's a valid UUID.

        try {
            var self = this;
            axios
                .put(`${config.baseURL}/facttypes/${id}`, {
                    enabled: this.state.facttype.enabled,
                    description: this.state.facttype.description
                })
                .then(function(response) {
                    self.setState({
                        saved: true,
                        isLoading: false,
                        error: {
                            hidden: false,
                            title: `${t('EditFactTypeForm.success')}:`,
                            style: 'success',
                            message: `${t('EditFactTypeForm.saved_message')}`
                        }
                    });
                })
                .catch(function(err) {
                    self.setState({
                        isLoading: false,
                        error: {
                            hidden: false,
                            title: `${t('.error')}:`,
                            style: 'danger',
                            message: err.response.data.message
                        }
                    });
                });
        } catch (e) {
            this.setState({
                isLoading: false,
                error: {
                    hidden: false,
                    title: `${t('EditFactTypeForm.error')}:`,
                    style: 'danger',
                    message: `${t('EditFactTypeForm.unknown_error')}`
                }
            });
        }
    };

    renderForm() {
        const { t } = this.props;

        return (
            <div id="EditFactTypeForm">
                <form onSubmit={this.handleSubmit}>
                    <Row bsClass="form-row">
                        <Col sm={12}>
                            <DismissableAlert
                                title={this.state.error.title}
                                message={this.state.error.message}
                                hidden={this.state.error.hidden}
                                style={this.state.error.style}
                            />
                        </Col>
                    </Row>
                    <Row bsClass="form-row">
                        <Col sm={12}>
                            <FormGroup controlId="enabled" bsSize="sm">
                                <label>{t('EditFactTypeForm.enabled')}</label>
                                <FormControl
                                    componentClass="select"
                                    placeholder="Choose..."
                                    value={this.state.facttype.enabled}
                                    onChange={this.handleChange}
                                >
                                    <option value="true">
                                        {t('EditFactTypeForm.true')}
                                    </option>
                                    <option value="false">
                                        {t('EditFactTypeForm.false')}
                                    </option>
                                </FormControl>
                                <small className="form-text text-muted">
                                    {t('EditFactTypeForm.required')}
                                </small>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row bsClass="form-row">
                        <Col sm={12}>
                            <FormGroup controlId="description" bsSize="sm">
                                <ControlLabel>
                                    {t('EditFactTypeForm.description')}
                                </ControlLabel>
                                <FormControl
                                    autoFocus
                                    type="text"
                                    value={this.state.facttype.description}
                                    onChange={this.handleChange}
                                />
                                <small className="form-text text-muted">
                                    {t('EditFactTypeForm.required')}
                                </small>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row bsClass="form-row">
                        <Col sm={12}>
                            <FormGroup bsSize="sm">
                                <SpinnerButton
                                    block
                                    bsStyle="primary"
                                    disabled={!this.validateForm()}
                                    type="submit"
                                    isLoading={this.state.isLoading}
                                    text={`${t(
                                        'EditFactTypeForm.save_facttype'
                                    )}`}
                                    loadingText={`${t(
                                        'EditFactTypeForm.saving_facttype'
                                    )}`}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </form>
            </div>
        );
    }

    render() {
        return <div className="EditFactTypeForm">{this.renderForm()}</div>;
    }
}

export default translate('translations')(EditFactTypeForm);
